<template>
  <div class="sp-template">
    <div class="h-title"></div>
    <div class="row">
        <el-form size="small" label-width="80px" :model="shippingForm" :rules="rulesShippingForm" ref="shippingForm">
          <el-form-item v-show="false" label="国家" :label-width="formLabelWidth" prop="country">
            <el-select v-model="shippingForm.country" placeholder="国家" @change="getCountry('SHIPPING')" filterable>
              <el-option v-for="item in baseAddressCountry" :key="item.id" :label="item.nameCn" :value="item.nameCn" v-if="item.code=='CN'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省" :label-width="formLabelWidth" prop="province">
            <el-select v-model="shippingForm.province" placeholder="省" @change="getProvince('SHIPPING')" filterable>
              <el-option v-for="item in baseAddressProveince" :key="item.id" :label="item.nameCn" :value="item.nameCn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市" :label-width="formLabelWidth" prop="city">
            <el-select v-model="shippingForm.city" placeholder="市" @change="gitCity('SHIPPING')" filterable>
              <el-option v-for="item in baseAddressCity" :key="item.id" :label="item.nameCn" :value="item.nameCn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" :label-width="formLabelWidth" prop="address">
            <el-input v-model="shippingForm.address" placeholder="详细地址"></el-input>
          </el-form-item>
          <el-form-item label="联系人" :label-width="formLabelWidth" prop="name">
            <el-input v-model="shippingForm.name" placeholder="联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model.number="shippingForm.phone" placeholder="联系电话"></el-input>
          </el-form-item>
          <el-form-item v-show="false" label="邮政编码" :label-width="formLabelWidth" prop="zipcode">
            <el-input v-model="shippingForm.zipcode" placeholder="邮政编码"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <el-checkbox v-model="shippingForm.defaultAddress">设为默认地址</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="fahandleSaveAddress('shippingForm')">保 存</el-button>
        </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
export default {
    props: {
        shippingForm: {
            type: Object,
            default: () => {
                return {
                    id: "",
                    country: "",
                    province: "",
                    city: "",
                    fbacode: "",
                    address: "",
                    name: "",
                    phone: "",
                    zipcode: "",
                    type: "SHIPPING",
                    defaultAddress: false
                };
            }
        }
    },
  data() {
    return {
      title: "",
      loading: true,
      dialogAddAddress: false,
      fadialogAddAddress: false,
      formLabelWidth: "120px",
      baseAddressCountry: [],
      baseAddressProveince: [],
      baseAddressCity: [],
      baseWarehouseData: [],
      baseFbaCode: [],
      receiveList: [],
      shippingList: [],
      rulesReceiveForm: {
        country: [{ required: true, message: "请选择国家", trigger: "change" }],
        province: [
          { required: true, message: "请选择省(直辖市、区)", trigger: "change" }
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { min: 10, message: "详细地址不可少于10字符", trigger: "blur" }
        ],
        zipcode: [
          { required: false}
        ],
        fbaWarehouseCode: [
          { required: true, message: "请选择FBA仓码", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入寄件人姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入寄件人手机号码", trigger: "blur" }
          // {
          //   // pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/,
          //   pattern: /^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
          //   message: "手机号码格式不正确",
          //   trigger: "blur"
          // }
        ]
      },
      rulesShippingForm: {
        country: [{ required: true, message: "请选择国家", trigger: "change" }],
        province: [
          { required: true, message: "请选择省(直辖市、区)", trigger: "change" }
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { min: 10, message: "详细地址不可少于10字符", trigger: "blur" }
        ],
        zipcode: [
          { required: false}
        ],
        fbaWarehouseCode: [
          { required: true, message: "请选择FBA仓码", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入寄件人姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入寄件人手机号码", trigger: "blur" }
          // {
          //   pattern: /^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
          //   message: "手机号码格式不正确",
          //   trigger: "blur"
          // }
        ]
      }
    };
  },
  components: {},
  created() {
    setTimeout(() => {
        this.initProvince(1)
        this.initCountry();
        this.loading = false;
    }, 1000);
  },
  methods: {
    // 获取国家列表
    initCountry() {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.baseAddressCountry = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 当选中国家后
    getCountry(type) {
      this.baseAddressProveince = [];
      this.baseAddressCity = [];
      this.baseFbaCode = [];
      let nameCn = "";
      if (type === "RECEIVE") {
        this.receiveForm.province = "";
        this.receiveForm.city = "";
        this.receiveForm.fbaWarehouseCode = "";
        nameCn = this.receiveForm.country;
      } else {
        this.shippingForm.province = "";
        this.shippingForm.city = "";
        this.shippingForm.fbaWarehouseCode = "";
        nameCn = this.shippingForm.country;
      }

      // 获取选择的国家id
      let countryId = "";

      for (let i = 0; i < this.baseAddressCountry.length; i++) {
        if (this.baseAddressCountry[i].nameCn == nameCn) {
          countryId = this.baseAddressCountry[i].id;
        }
      }

      if (countryId == "") {
        return;
      }
      this.initProvince(countryId);
    },
    // 获取省份列表
    initProvince(countryId) {
      this.$request1({
        type: "GET",
        url: '/province/' + countryId + '',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.baseAddressProveince = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 当选择州或省后
    getProvince(type) {
      this.baseAddressCity = [];
      this.baseFbaCode = [];
      let nameCn = "";
      if (type === "RECEIVE") {
        this.receiveForm.city = "";
        this.receiveForm.fbaWarehouseCode = "";
        nameCn = this.receiveForm.province;
      } else {
        this.shippingForm.city = "";
        this.shippingForm.fbaWarehouseCode = "";
        nameCn = this.shippingForm.province;
      }
      // 获取选择的州或省id
      let provinceId = "";

      for (let i = 0; i < this.baseAddressProveince.length; i++) {
        if (this.baseAddressProveince[i].nameCn == nameCn) {
          provinceId = this.baseAddressProveince[i].id;
        }
      }

      if (provinceId == "") {
        return;
      }
      this.initCity(provinceId);
    },
    // 获取城市列表
    initCity(provinceId) {
      this.$request1({
        type: "GET",
        url: '/city/' + provinceId + '',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.baseAddressCity = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    gitCity(type) {
      this.baseFbaCode = [];
      let provinceCn = "";
      let nameCn = "";
      if (type === "RECEIVE") {
        this.receiveForm.fbaWarehouseCode = "";
        provinceCn = this.receiveForm.province;
        nameCn = this.receiveForm.city;
      } else {
        this.shippingForm.fbaWarehouseCode = "";
        provinceCn = this.shippingForm.province;
        nameCn = this.shippingForm.city;
      }

      let city = "";
      let province = "";
      for (let i = 0; i < this.baseAddressProveince.length; i++) {
        if (this.baseAddressProveince[i].nameCn == provinceCn) {
          province = this.baseAddressProveince[i].nameEn;
        }
      }

      for (let i = 0; i < this.baseAddressCity.length; i++) {
        if (this.baseAddressCity[i].nameCn == nameCn) {
          city = this.baseAddressCity[i].nameEn;
        }
      }

      if (city == "") {
        return;
      }

      this.$request1({
        method: 'GET',
        url: '/warehouseCode',
        xhrFields: {
          withCredentials: true
        },
        params: {
          province: province,
          city: city
        }
      })
        .then(response => {
          console.log(response.data);
          this.baseFbaCode = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //清除验证
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    address(country, provinceNameCn, cityNameCn) {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.baseAddressCountry = response.data.data;
          let countryId = "";
          for (let i = 0; i < this.baseAddressCountry.length; i++) {
            if (this.baseAddressCountry[i].nameCn == country) {
              countryId = this.baseAddressCountry[i].id;
            }
          }
          this.$request1({
            type: "GET",
            url: '/province/' + countryId + '',
            xhrFields: {
              withCredentials: true
            },
            params: {}
          })
            .then(response => {
              this.baseAddressProveince = response.data.data;
              let provinceId = "";
              for (let i = 0; i < this.baseAddressProveince.length; i++) {
                if (this.baseAddressProveince[i].nameCn == provinceNameCn) {
                  provinceId = this.baseAddressProveince[i].id;
                }
              }
              this.$request1({
                type: "GET",
                url: '/city/' + provinceId + '',
                xhrFields: {
                  withCredentials: true
                },
                params: {}
              })
                .then(response => {
                  this.baseAddressCity = response.data.data;
                  let province = "";
                  let city = "";
                  for (let i = 0; i < this.baseAddressProveince.length; i++) {
                    if (this.baseAddressProveince[i].nameCn == provinceNameCn) {
                      province = this.baseAddressProveince[i].nameEn;
                    }
                  }
                  for (let i = 0; i < this.baseAddressCity.length; i++) {
                    if (this.baseAddressCity[i].nameCn == cityNameCn) {
                      city = this.baseAddressCity[i].nameEn;
                    }
                  }
                  this.$request1({
                    type: "GET",
                    url: '/warehouseCode',
                    xhrFields: {
                      withCredentials: true
                    },
                    params: {
                      province: province,
                      city: city
                    }
                  })
                    .then(response => {
                      this.baseFbaCode = response.data;
                    })
                    .catch(error => {
                      console.log(error);
                    });
                })
                .catch(error => {
                  console.log(error);
                });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    //设为默认地址
    handleClick(row) {
      this.$request1({
        method: 'GET',
        url: '/address/check',
        params: {
          id: row.id,
          type: row.type,
          isDefault: true
        }
      })
        .then(response => {
          
        })
        .catch(error => {
          console.log(error);
        });
    },
    //删除地址
    deleteAddress(index, row) {
      let _this = this;
      this.$confirm("此操作将永久删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'GET',
            url: '/address/delete',
            params: {
              id: row.id
            }
          })
            .then(response => {
              if (row.type == "RECEIVE") {
                _this.receiveList.splice(index, 1);
              } else {
                _this.shippingList.splice(index, 1);
              }
              this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success"
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    //保存地址
    fahandleSaveAddress(formName) {
        let _this = this;
        this.shippingForm.country="中国";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'POST',
            url: '/address/save',
            data: this.shippingForm
          })
            .then(response => {
              if (response.data.success) {
                if (response.data.message == "create.shipping") {
                  this.$notify({
                    title: "成功",
                    message: "添加发件人地址成功",
                    type: "success"
                  });
                } else {
                  this.$notify({
                    title: "成功",
                    message: "修改发件人地址成功",
                    type: "success"
                  });
                }
                try {
                    _this.$emit("closeAddressPanel");
                }catch(err){
                    console.error(err);
                }

              } else {
                this.$notify.error({
                  title: "错误",
                  message: response.data.message
                });
              }
              this.rulesForm(formName);
            })
            .catch(error => {
              console.log(error);
            });
          this.fadialogAddAddress = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑地址
    fahandleEditAddress(index, row) {
      this.title = row ? "编辑地址" : "新增地址";
      this.fadialogAddAddress = true;
      if (row === undefined || row.id === "") {
        
        this.shippingForm = {
          id: "",
          name: "",
          zipcode: "",
          fbaWarehouseCode: "",
          country: "",
          province: "",
          city: "",
          address: "",
          type: "SHIPPING",
          defaultAddress: false
        };
      } else {
        this.shippingForm = JSON.parse(JSON.stringify(row));
        this.address(row.country, row.province, row.city);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/usercenter/address_dialog.vue